
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("etwfl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d86217a304f7402f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $d86217a304f7402f$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': 'Acties',
    'ai-smart-button.ai-actions.give-feedback-action.title': 'Feedback geven',
    'ai-smart-button.ai-actions.help.section.text': 'Help',
    'ai-smart-button.ai-actions.input.link-picker-button-label': 'Link',
    'ai-smart-button.ai-actions.input.mention-button-label': 'Vermelding',
    'ai-smart-button.ai-actions.input.placeholder': 'Typ wat je nodig hebt',
    'ai-smart-button.ai-actions.input.send-button-label': 'Verzenden',
    'ai-smart-button.ai-actions.item.betaLozenge': "B\xc8TA",
    'ai-smart-button.ai-actions.item.newLozenge': 'NIEUW',
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Pictogram toevoegen',
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Pictogram automatisering',
    'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatiseringen',
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Agents zoeken',
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Automatisering aanmaken',
    'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Hoe kan ik helpen?',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hallo {name},',
    'ai-smart-button.ai-proactive-nudge.dismiss': 'Negeren',
    'ai-smart-button.feedback-action.ask-question-option': 'Een vraag stellen',
    'ai-smart-button.feedback-action.cancel-button-label': 'Annuleren',
    'ai-smart-button.feedback-action.choose-feedback-option': 'Kies er een',
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'De bug of issue beschrijven',
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Laat ons weten wat je vindt',
    'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Wat zou je willen weten?',
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Laat ons weten wat je zou willen verbeteren',
    'ai-smart-button.feedback-action.leave-comment-option': 'Laat een reactie achter',
    'ai-smart-button.feedback-action.report-bug-option': 'Rapporteer een bug',
    'ai-smart-button.feedback-action.research-participation-message': 'Ik wil graag meewerken aan productonderzoek',
    'ai-smart-button.feedback-action.select-feedback-heading': 'Feedback selecteren',
    'ai-smart-button.feedback-action.submit-button-label': 'Feedback sturen',
    'ai-smart-button.feedback-action.suggest-improvement-option': 'Een verbetering voorstellen',
    'ai-smart-button.feedback-action.title': 'Feedback geven',
    'ai-smart-button.feedback-item.icon-label': 'Feedbackpictogram',
    'ai-smart-button.reference.close-button-label': 'Sluiten',
    'quick-summary.feedback.summary.placeholder': 'Wat heeft Atlassian Intelligence goed gedaan? Wat kan er beter?',
    'quick-summary.feedback.title': 'Help ons Atlassian Intelligence te verbeteren'
};

});


//# sourceMappingURL=nl.33d77ee5.js.map
